import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import APP from '../../modules';

export const designHomeView = (props) => {
  const TestDataManagement = localStorage.getItem('TestDataManagement');
  const TestDesign = localStorage.getItem('TestDesign');
  const TestCheck = sessionStorage.getItem('TestCheck');
  const { testViewClick } = props;
  return (
    <div className='home__container'>
      <div className='container mt-4'>
        <div className='row d-flex justify-content-center'>
          <div className='col-md-6 px-3 py-3 mt-5 welcome-div'>
            <h2 className='text-center'>Welcome to XTForge</h2>
            <h6 className='mt-4 text-center'>What you would like to do</h6>
            {TestDataManagement === 'true' && TestCheck === 'TestData' && (
              <div className='mt-4 col text-center'>
                <Link to={APP.Constants.ROUTES.TEST_DATA_MANAGEMENT}>
                  <button className='btn btn-color btn-width-230 mx-3 my-2'>
                    Create Test Data
                  </button>
                </Link>
              </div>
            )}
            {TestDesign === 'true' && TestCheck === 'TestDesign' && (
              <div className='mt-4 col text-center'>
                <Link to={APP.Constants.ROUTES.TEST_CONFIG}>
                  <button className='btn btn-color btn-width-230 mx-3 my-2'>
                    Create New Test
                  </button>
                </Link>
              </div>
            )}
            {TestDesign === 'true' && TestCheck === 'TestDesign' && (
              <div className='mt-2 col text-center'>
                <button
                  className='mx-2 btn btn-width-230 btn-color'
                  onClick={() => testViewClick('TestDesign')}
                >
                  View Existing Test
                </button>
              </div>
            )}
            {TestDataManagement === 'true' && TestCheck === 'TestData' && (
              <div className='mt-2 col text-center'>
                <Link to={APP.Constants.ROUTES.VIEW_REQUIREMENT}>
                  <button
                    className='mx-2 btn btn-width-230 btn-color'
                    onClick={() => testViewClick('TestData')}
                  >
                    View Test Data
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
